import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  deleteProperty,
  disableProperty,
  getProperties,
} from "../../services/PropertiesServices";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { Constants, LABELS } from "../../Constants";
import placeholderImage from "../../assets/images/image_placeholder.jpg";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import meliLogo from "../../assets/images/logo_meli_2.png";
import infoCasasLogo from "../../assets/images/info_casas_logo.png";
import Dropzone from "react-dropzone";
import { imageUpload } from "src/services/BannersServices";
import axios from "axios";
import ViewInWeb from "src/components/Common/ViewInWeb";

export default function PropertiesList() {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [pages, setPages] = useState(0);
  const history = useHistory();
  const [page, setPage] = useState(0);
  const [bannerDesktop, setBannerDesktop] = useState();
  const [bannerMobile, setBannerMobile] = useState();
  const [imageTmp, setImageTmp] = useState("");
  const [pathname] = useState(window.location.pathname);

  const instance = axios.create({ baseURL: Constants.BASE_URL });

  useEffect(() => {
    fetchItems();
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    fetchItems();
  }, [page]);

  const fetchItems = async () => {
    setLoading(true);
    try {
      let response = await getProperties({
        page: page + 1,
        token: "",
      });
      setItems(response.data.data.properties);
      setPages(response.data.data.pages);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const remove = async (id: number) => {
    setLoading(true);
    try {
      let response = await deleteProperty({
        token: "",
        id,
      });
      setLoading(false);
      fetchItems();
      toast(`Propiedad eliminado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const disable = async (id: number) => {
    setLoading(true);
    try {
      let response = await disableProperty({
        token: "",
        id,
      });
      setLoading(false);
      fetchItems();
      toast(`Propiedad desactivada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const goToProperties = (id: number) => {
    history.push(`/properties/${id}`);
  };

  const updateProperties = async (data: any) => {
    try {
      const httpOptions = {
        headers: {
          Authorization: data.token,
        },
      };
      return await instance.put(
        `/brokers`,
        { ...data, type: "properties" },
        httpOptions
      );
    } catch (error) {
      throw error;
    }
  };

  const handleAcceptedFiles = async (files: any, hook: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "news",
        });
        if (hook === "banner_desktop") {
          setBannerDesktop(response.data.data.image);
        } else if (hook === "banner_mobile") {
          setBannerMobile(response.data.data.image);
        } else {
          setImageTmp(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchProperties({
        token: "",
      });
      const { banner_desktop, banner_mobile } = response.data.data;
      setBannerDesktop(banner_desktop);
      setBannerMobile(banner_mobile);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const fetchProperties = async (data: any) => {
    try {
      const httpOptions = {
        headers: {
          Authorization: data.token,
        },
      };
      return await instance.get(`/brokers?type=properties`, httpOptions);
    } catch (error) {
      throw error;
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let data = {
        bannerDesktop,
        bannerMobile,
      };

      await updateProperties({
        token: "",
        ...data,
      });

      setLoading(false);
      toast(`Brokers actualizado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs
          title="Listado de propiedades"
          breadcrumbItem="Listado de propiedades"
        />

        {pathname.includes("config") ? (
          <Row style={{ marginBottom: "1rem" }}>
            <Col className="row">
              <FormGroup className="col-md-6">
                <Label>Banner Desktop</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner_desktop");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {bannerDesktop && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${bannerDesktop}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
              <FormGroup className="col-md-6">
                <Label>Banner Mobile</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner_mobile");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {bannerMobile && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${bannerMobile}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link={`https://mariomendez.uy/propiedades`} />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <Row style={{ marginBottom: "1rem" }}>
              <Col>
                <Label>Subir archivo excel</Label>
                <Input type="file" style={{ marginLeft: "0.5rem" }} />
              </Col>
              <Col
                style={{
                  alignItems: "end",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <Button
                  onClick={() => history.push("/properties/0")}
                  color="primary"
                  type="submit"
                >
                  Agregar nueva propiedad
                </Button>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="table-rep-pmlugin">
                  <div className="table-responsive mb-0">
                    <Table className="table table-striped table-bordered">
                      <Thead>
                        <Tr>
                          <Th></Th>
                          <Th>#</Th>
                          <Th>Título</Th>
                          <Th>Ubicación</Th>
                          <Th>Publicado</Th>
                          <Th>Estado</Th>
                          <Th>Visible</Th>
                          <Th></Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {(items || []).map((item: any) => (
                          <Tr>
                            <Th style={{ width: "60px" }}>
                              {item?.medias ? (
                                <img
                                  width="75"
                                  src={`${Constants.BASE_URL}${item.medias.image}`}
                                  alt=""
                                />
                              ) : (
                                <img src={placeholderImage} alt="" width="75" />
                              )}
                            </Th>
                            <Th>{item.id}</Th>
                            <Th>{item.title}</Th>
                            <Th>
                              {item.city?.name}, {item.state?.name}
                            </Th>
                            <Th>
                              {item.meli_shared && item.meli_id ? (
                                <img src={meliLogo} alt="" width={25} />
                              ) : null}

                              {item.info_casas_shared ? (
                                <img
                                  src={infoCasasLogo}
                                  alt=""
                                  width={35}
                                  style={{ marginLeft: "0.25rem" }}
                                />
                              ) : null}

                              {!item.meli_shared && !item.info_casas_shared
                                ? "-"
                                : null}
                            </Th>
                            <Th>
                              <span>
                                {item.label
                                  ? LABELS[item.label as keyof typeof LABELS]
                                  : "Disponible"}
                              </span>
                            </Th>
                            <Th>{item.visible ? "Si" : "No"}</Th>
                            <Th>
                              <button
                                onClick={() => goToProperties(item.id)}
                                className="button-action-left"
                              >
                                Editar
                              </button>
                              |
                              <button
                                className="button-action-rigth button-action-left"
                                onClick={() => disable(item.id)}
                              >
                                {item.visible ? "Ocultar" : "Mostrar"}
                              </button>
                              |
                              <button
                                className="button-action-rigth"
                                onClick={() => remove(item.id)}
                              >
                                Eliminar
                              </button>
                            </Th>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <div>
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={(e) => setPage(e.selected)}
                        pageRangeDisplayed={5}
                        pageCount={pages}
                        previousLabel="<"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </div>
  );
}
